
export function getAlliance(uid: string) {
  return (['red', 'blue'] as ['red', 'blue'])[uid.charCodeAt(0) % 2];
}

export function normalizeEventKey(eventKey?: string|null) {
  if(!eventKey) return '';

  return eventKey.toLowerCase();
}
